import { useCallback } from "react";
import type { Period } from "@repo/core";
import moment from "moment";

export function usePeriod() {
  const getPeriodStart = useCallback((period: Period) => {
    const periodMap: Record<Period, () => Date> = {
      "1M": () => moment().subtract(1, "month").toDate(),
      "3M": () => moment().subtract(3, "month").toDate(),
      YTD: () => moment().startOf("year").toDate(),
      "1Y": () => moment().subtract(1, "year").toDate(),
      "2Y": () => moment().subtract(2, "year").toDate(),
      "3Y": () => moment().subtract(3, "year").toDate(),
      "5Y": () => moment().subtract(5, "year").toDate(),
      "10Y": () => moment().subtract(10, "year").toDate(),
      ALL: () => new Date(0),
    };

    return moment(periodMap[period]()).startOf("month").format("YYYY-MM-DD");
  }, []);

  return { getPeriodStart };
}
